import { useAuthContext } from '../../context/AuthContext';

import { Button } from '../elements/Button.jsx';
/**
 * 🫥 "You are looking at the guest experience" — and the way back.
 *
 * Mounted at the app root rather than inside GuestLayout, because during a
 * preview the session reports itself as signed out and any navigation to an
 * authenticated route lands on /login. Somebody who wandered there would be
 * staring at a sign-in form while actually signed in, with no visible way
 * home. A root-level banner means the exit exists on every route the preview
 * can reach, including the ones it reaches by accident.
 *
 * Fixed to the bottom so it never covers the public header — the header is
 * usually the thing being checked, since its signed-out CTA is the most
 * common reason to open this at all.
 */
export const GuestPreviewBanner = () => {
  const { isGuestPreview, previewingAs, endPreview } = useAuthContext();
  if (!isGuestPreview) return null;

  const who = previewingAs?.email || previewingAs?.username || 'your staff account';

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-slate-700 bg-slate-900 px-4 py-3 text-white shadow-2xl md:px-8"
    >
      <div className="mx-auto flex max-w-[1600px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="text-xs font-black uppercase tracking-wide text-slate-300">Guest preview</p>
          <p className="truncate text-sm text-slate-100">
            Viewing Moksy as a signed-out visitor. You are still signed in as{' '}
            <span className="font-semibold">{who}</span>.
          </p>
          {/* Said plainly, because the alternative is an operator concluding
              from a personalised widget that guest data is leaking. */}
          <p className="mt-0.5 text-[11px] leading-snug text-slate-400">
            Layout and navigation only — requests still use your session, so this is not a test of
            what a guest is allowed to read.
          </p>
        </div>
        <Button variant="outline" size="sm" pill={false} className="shrink-0 uppercase"
          onClick={() => endPreview()}>
          Exit Preview
        </Button>
      </div>
    </div>
  );
};

export default GuestPreviewBanner;
